import { OnyxEvent } from '../models/event';
import { Party } from '../models/party';

export class EventUtils {
  static isEventValid(onyxEvent: OnyxEvent): boolean {
    return Boolean(
      onyxEvent &&
      this.isEventBasicInformationValid(onyxEvent) &&
      this.isEventStartEndDateValid(onyxEvent) &&
      this.isEventPropertyValid(onyxEvent.eventProperty) &&
      this.isEventAgencyValid(onyxEvent.eventAgency));
  }

  static isEventBasicInformationValid(onyxEvent: OnyxEvent): boolean {
    return Boolean(
      onyxEvent.name &&
      onyxEvent.chain &&
      onyxEvent.brand &&
      onyxEvent.propertyId);
  }

  static isEventPropertyValid(eventProperty: Party): boolean {
    return Boolean(eventProperty && eventProperty.eventReferenceNumber && eventProperty.name);
  }

  static isEventAgencyValid(eventAgency: Party): boolean {
    return Boolean(eventAgency && eventAgency.name);
  }

  static isEventStartEndDateValid(onyxEvent: OnyxEvent): boolean {
    return Boolean(
      onyxEvent.startDate &&
      onyxEvent.endDate &&
      new Date(onyxEvent.startDate) < new Date(onyxEvent.endDate));
  }

  static doesEventHaveAgency(onyxEvent: OnyxEvent): boolean {
    return Boolean(onyxEvent.agencyId && onyxEvent.eventAgency);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/event-utils.ts